/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authServiceAccountsUpdateApiKey } from "../../funcs/authServiceAccountsUpdateApiKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateServiceAccountApiKeyRequest$inboundSchema,
};

export const tool$authServiceAccountsUpdateApiKey: ToolDefinition<typeof args> =
  {
    name: "auth-service-accounts-update-api-key",
    description: `Update a service-account API key`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await authServiceAccountsUpdateApiKey(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
